import api from './api';

// AKM POC §6.1 — Personel Statüleri okuma ucu (EM.Read; sayfalı PaginatedList, SortOrder + Name sıralı).
export const getEmployeeStatuses = (params) => api.get('/v1/employee-statuses', { params });
export const getEmployeeStatus = (id) => api.get(`/v1/employee-statuses/${id}`);
